const colors = {
  base: '#2b3245',
  bg_base: '#364456',
  textMain: '#364456',
  bg_grey: '#EDEDED',
}
export default colors
